import { SxPropsTypes } from 'theme/MuiThemeProvider/types';

export const styles: SxPropsTypes = {
  button: {
    width: '24px',
    height: '24px',
    padding: 0,
  },
};
